import React, { memo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { servicePath } from "../../../utils/serviceRoutes";
import { getServiceIconSrc } from "../../../data/serviceIcons";

const MenuItem = memo(({ service, onNavigate, categorySlug: catSlug }) => {
  const { t } = useTranslation();
  const titleKey = `serviceCatalog.${service.id}.title`;
  const descKey = `serviceCatalog.${service.id}.description`;
  const title = t(titleKey);
  const desc = t(descKey);
  const to = servicePath(service);
  const iconSrc = getServiceIconSrc(service.id);

  return (
    <li
      className="menu-item menu-item-type-post_type menu-item-object-services vh-nav-service-item"
      data-vh-cat={catSlug}
    >
      <Link
        to={to}
        className="dropdown-item vh-nav-service-link"
        onClick={onNavigate}
      >
        <span className="vh-nav-service-link__icon" aria-hidden="true">
          <img src={iconSrc} alt="" width={36} height={36} decoding="async" />
        </span>
        <span className="menu-title vh-nav-service-link__title">
          {title === titleKey ? service.title : title}
        </span>
        <span className="description vh-nav-service-link__desc">
          {desc === descKey ? service.description : desc}
        </span>
      </Link>
    </li>
  );
});

export default MenuItem;
